export default {
  pageTitle: "Customer Email",
  pageDescription:
    "Configure how invoices, receipts, and reminders are sent to your clients.",
  tabSenderDomain: "Sender Domain",
  tabContactTypes: "Contact Types",
};
